import React from 'react'
import PropTypes from 'prop-types'
import ChatContainer from './components/ChatContainer'

function AiChatApp({ conversationId, messages, providers, currentProvider, compact, context, originPage }) {
  return (
    <ChatContainer
      conversationId={conversationId}
      initialMessages={messages}
      providers={providers}
      currentProvider={currentProvider}
      compact={compact}
      context={context}
      originPage={originPage}
    />
  )
}

AiChatApp.propTypes = {
  conversationId: PropTypes.number,
  messages: PropTypes.array,
  providers: PropTypes.array,
  currentProvider: PropTypes.string,
  compact: PropTypes.bool,
  context: PropTypes.object,
  originPage: PropTypes.string
}

AiChatApp.defaultProps = {
  conversationId: null,
  messages: [],
  providers: ['claude', 'gemini', 'openai'],
  currentProvider: 'claude',
  compact: false,
  context: null,
  originPage: null
}

export default AiChatApp
